import React from 'react'
import {connect} from 'react-redux'
import SetupForm from "./SetupForm";
import {configure, loadWidget, loadBridge} from './SetupActions';
import {finish} from '../steps/StepsActions';
import {STEP_SETUP_ENVIRONMENT} from "../steps/StepsContants";

const SetupContainer = ({configure, loadWidget, loadBridge, finish, state}) => {

  const onSubmit = values => {
    const onBridgetLoaded = () => {
      configure(values, state.app.config.environment, state.app.defaultMerchantId);
      finish(STEP_SETUP_ENVIRONMENT);
      window.PayEngine.setPublishableKey(state.app.config.environment.merchantId);
    };

    loadWidget(values, () => {
      loadBridge(values, onBridgetLoaded);
    });
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-6 col-md-8">
        <SetupForm onSubmit={values => onSubmit(values)}/>
      </div>
    </div>
  );
};

SetupContainer.propTypes = {};

const mapStateToProps = (state) => ({
  state: state
});

export default connect(
  mapStateToProps,
  {configure, loadWidget, loadBridge, finish}
)(SetupContainer);



// WEBPACK FOOTER //
// ./src/setup/SetupContainer.js